import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import "./form-item-insurance-personal-service-plan-form.component.scss";
var FormItemInsurancePersonalServicePlanForm = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemInsurancePersonalServicePlanForm, _super);
    function FormItemInsurancePersonalServicePlanForm(element) {
        var _this = _super.call(this, element) || this;
        _this.url = "";
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemInsurancePersonalServicePlanForm.prototype.init = function () {
        this.form = this.element.querySelector("form");
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector(".form-container__error");
        }
        this.selectQueryType = this.element.querySelector("select[name=query-type]");
        this.productType = this.element.querySelector("select[name=product-type]");
        this.productTypeHidden = this.element.querySelector("input[name=product-type-hidden]");
        this.productCategory = this.element.querySelector("input[name=product-category]");
        this.productSubCategory = this.element.querySelector("input[name=product-sub-category]");
        this.formFieldsContainer = this.element.querySelector("div.form-container__fields");
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-apply-now__button"));
        this.recipientInput = this.element.querySelector("input[name=recipient]");
        this.emailInput = this.element.querySelector("input[name=email]");
        this.subjectInput = this.element.querySelector("input[name=subject]");
        this.phoneNumber = this.element.querySelector("input");
        this.confirmContactNumberBtn = this.element.querySelector("input[name=confirm-phone-number]");
        this.selectProductInterestedType = this.element.querySelector("select[name=product-interest-type]");
        this.selectProductInterestedTypeContainer = this.element.querySelector("div.form-item__insurance--personal__product-interest-type-container");
        // New change
        this.PolicyNumberType = this.element.querySelector("select[name=policy-number]");
        this.PolicyNumberTypeContainer = this.element.querySelector("div.form-item__insurance--personal__policy-number-type-container");
        this.showVehicleWarreties = this.element.querySelector("div.showvehiclecontainer");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
    };
    FormItemInsurancePersonalServicePlanForm.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) {
            return item.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_this.form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.showDisplayView("loader");
                    // Check if gRecaptcha is enabled for this form
                    if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                        var gToken_1 = '';
                        try {
                            // Attempt to get recaptcha token
                            grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var err_1;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                        case 1:
                                            gToken_1 = _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            err_1 = _a.sent();
                                            // Log error
                                            console.log("Unable to retrieve gRecaptcha Token");
                                            console.log(err_1);
                                            return [3 /*break*/, 3];
                                        case 3:
                                            // Set recaptcha token
                                            this.gRecaptchaToken = gToken_1;
                                            this.submitForm(this.form);
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        catch (err) {
                            // Log error
                            console.log("Unable to retrieve gRecaptcha Token");
                            console.log(err);
                            _this.submitForm(_this.form);
                        }
                    }
                    else {
                        _this.submitForm(_this.form);
                    }
                }
            });
        });
        this.showLessBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute("hidden", "true");
            _this.showMoreBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
        });
        this.showMoreBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute("hidden", "true");
            _this.showLessBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.removeAttribute("hidden");
        });
        this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
            _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
            _this.dataSharingGroupShowBtn.removeAttribute("hidden");
        });
        this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute("hidden");
            _this.dataSharingGroupHideBtn.removeAttribute("hidden");
            _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
            _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute("hidden");
            _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
        });
        this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
        });
        if (this.productCategory && this.productSubCategory) {
            this.numberOfProducts = this.populateProducts(this.productCategory.value, this.productSubCategory.value);
            this.productName = this.getProductName(this.productCategory.value, this.productSubCategory.value);
        }
        else {
            this.numberOfProducts = this.populateProducts("", "");
            this.productName = this.getProductName("", "");
        }
        if (this.selectQueryType) {
            this.selectQueryType.addEventListener("change", function (event) {
                return _this.queryTypeSelection(event);
            });
        }
        if (this.selectProductInterestedType) {
            this.selectProductInterestedType.addEventListener("change", function (event) { return _this.productInterestedTypeSelection(event); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        //this.validationService.addError();
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
            // Reset the form
            this.form.addEventListener("custom_form_reset_event", function (e) {
                var valid = Array.from(_this.form.querySelectorAll(".form__group--error"));
                valid.map(function (pElem) {
                    pElem.classList.remove("form__group--error");
                    var errorMessage = pElem.querySelector(".form__group--error_message");
                    if (errorMessage) {
                        errorMessage.remove();
                    }
                });
                _this.resetForm();
            }, false);
        }
        var _contactNumber = this.form.querySelector("input[name=phone-number]");
        var _contactConfirmNumber = this.form.querySelector("input[name=confirm-phone-number]");
        // Ok key
        if (this.confirmContactNumberBtn) {
            this.confirmContactNumberBtn.addEventListener("blur", function (e) {
                e.preventDefault();
                _this.validateConfirmContactNumber(_contactNumber, _contactConfirmNumber);
            });
        }
    };
    // Vinayak Haral
    FormItemInsurancePersonalServicePlanForm.prototype.validateConfirmContactNumber = function (contactNumber, contactConfirmNumber) {
        var error = ["Confirm Phone number is not match"];
        var isValid = true;
        var _contactConfirmNumber = this.form.querySelector("input[name=confirm-phone-number]");
        if (contactNumber.value !== contactConfirmNumber.value) {
            //  Password doesnot match
            isValid = false;
            this.validationService.addError(_contactConfirmNumber, error);
            //	_contactConfirmNumber.classList.add(`form__group--error`);
            // let _errorDiv = document.createElement(`div`);
            // _errorDiv.classList.add(`form__group--error_message`);
            // const _errors = document.createElement(`ul`);
            // _errorDiv = document.createElement(`div`);
            // _errorDiv.classList.add(`form__group--error_message`);
            // const _error = document.createElement(`li`);
            // _error.innerHTML = confirmErrorDetails;
            // _errors.appendChild(_error);
            // _errorDiv.appendChild(_errors);
        }
        return isValid;
    };
    FormItemInsurancePersonalServicePlanForm.prototype.queryTypeSelection = function (event) {
        var element = event.target;
        var value = element.value;
        var fieldContainer = this.form.querySelector("div.form-container__fields");
        var fieldClaimNumber = fieldContainer.querySelector("div.form__group--claim-number");
        if (this.showVehicleWarreties) {
            this.showVehicleWarreties.classList.add("form__group--hidden");
        }
        if (fieldClaimNumber) {
            fieldContainer.removeChild(fieldClaimNumber);
        }
        this.form.setAttribute("id", "apply-now-submit_application_insurance");
        this.queryType = value;
        // SERVICING REQUEST
        if (this.queryType === "servicingRequest") {
            var selectQuoteProductContainer = this.element.querySelector(".form__group--quote-select");
            if (selectQuoteProductContainer) {
                selectQuoteProductContainer.classList.add("form__group--hidden");
            }
            if (this.numberOfProducts === 1) {
                this.selectProductInterestedTypeContainer.classList.add("form__group--hidden");
            }
            else {
                this.selectProductInterestedTypeContainer.classList.remove("form__group--hidden");
            }
            // this.createInput(
            // 	"Policy number",
            // 	"policy-number",
            // 	"Enter your policy number",
            // 	false
            // );
            this.PolicyNumberTypeContainer.classList.remove("form__group--hidden");
            // CLAIMS REQUEST
        }
        else if (this.queryType === "claimsRequest") {
            var selectQuoteProductContainer = this.element.querySelector(".form__group--quote-select");
            if (selectQuoteProductContainer) {
                selectQuoteProductContainer.classList.add("form__group--hidden");
            }
            if (this.numberOfProducts === 1) {
                this.selectProductInterestedTypeContainer.classList.add("form__group--hidden");
            }
            else {
                this.selectProductInterestedTypeContainer.classList.remove("form__group--hidden");
            }
            // this.createInput(
            // 	"Policy/Claim number",
            // 	"policy-claim-number",
            // 	"Enter your policy or claim number",
            // 	false
            // );
            this.PolicyNumberTypeContainer.classList.remove("form__group--hidden");
            // QUOTE / SALES
        }
        else if (this.queryType === "quote") {
            this.selectProductInterestedTypeContainer.classList.add("form__group--hidden");
            this.PolicyNumberTypeContainer.classList.add("form__group--hidden");
            if (this.showVehicleWarreties) {
                this.showVehicleWarreties.classList.remove("form__group--hidden");
            }
            else {
                this.checkIfCarWarranties();
            }
        }
        else {
            this.selectProductInterestedTypeContainer.classList.add("form__group--hidden");
            this.PolicyNumberTypeContainer.classList.add("form__group--hidden");
        }
    };
    FormItemInsurancePersonalServicePlanForm.prototype.checkIfCarWarranties = function () {
        var _productTypeLSID = this.element.querySelector("select[name=product-type]");
        var _productTypeHiddenLSID = this.element.querySelector("input[name=product-type-hidden]");
        var productLSID = "";
        if (_productTypeLSID) {
            productLSID = _productTypeLSID.value;
        }
        else {
            if (_productTypeHiddenLSID) {
                productLSID = _productTypeHiddenLSID.value;
            }
        }
        if (productLSID === "MVW") {
            if (!this.element.querySelector("select[name=quote-product]")) {
                var _quoteSelectInput = this.createQuoteInput("Product", "quote-product", true);
                this.createQuoteOption(_quoteSelectInput, "Select Product", "");
                this.createQuoteOption(_quoteSelectInput, "Extended Vehicle Warranty", "Extended Vehicle Warranty");
                this.createQuoteOption(_quoteSelectInput, "Pre-owned Vehicle Warranty", "Pre-owned Vehicle Warranty");
            }
            else {
                var selectQuoteProductContainer = this.element.querySelector(".form__group--quote-select");
                if (selectQuoteProductContainer) {
                    selectQuoteProductContainer.classList.remove("form__group--hidden");
                }
            }
        }
    };
    FormItemInsurancePersonalServicePlanForm.prototype.createQuoteInput = function (label, name, required) {
        if (required === void 0) { required = false; }
        var container = this.formFieldsContainer;
        var fieldBefore = container.querySelector("div.popia-consent-div");
        var fieldContainer = document.createElement("div");
        fieldContainer.classList.add("form__group");
        fieldContainer.classList.add("form__group--quote-select");
        var fieldLabel = document.createElement("label");
        fieldLabel.classList.add("form__label");
        fieldLabel.innerHTML = label;
        var selectInput = document.createElement("select");
        selectInput.classList.add("form__input");
        if (required) {
            selectInput.classList.add("form__input--required");
        }
        selectInput.setAttribute("name", name);
        fieldContainer.appendChild(fieldLabel);
        fieldContainer.appendChild(selectInput);
        container.insertBefore(fieldContainer, fieldBefore);
        return selectInput;
    };
    FormItemInsurancePersonalServicePlanForm.prototype.createQuoteOption = function (selectField, name, value) {
        var option = document.createElement("option");
        option.textContent = name;
        option.value = value;
        selectField.appendChild(option);
    };
    FormItemInsurancePersonalServicePlanForm.prototype.productInterestedTypeSelection = function (event) {
        var element = event.target;
        var value = element.value;
        this.productInterestedType = value;
    };
    FormItemInsurancePersonalServicePlanForm.prototype.productInterestedTypeNoSelection = function (value) {
        this.productInterestedType = value;
    };
    // createInput(
    // 	label: any,
    // 	name: any,
    // 	placeholder: any = "",
    // 	required: boolean = false,
    // 	type: any = ""
    // ) {
    // 	const container: any = this.formFieldsContainer;
    // 	const fieldBefore: any = container.querySelector(
    // 		"div.popia-consent-div"
    // 	);
    // 	const fieldContainer: any = document.createElement("div");
    // 	fieldContainer.classList.add("form__group");
    // 	fieldContainer.classList.add("form__group--claim-number");
    // 	const fieldLabel: any = document.createElement("label");
    // 	fieldLabel.classList.add("form__label");
    // 	fieldLabel.innerHTML = label;
    // 	const fieldInput: any = document.createElement("input");
    // 	fieldInput.classList.add("form__input");
    // 	if (required) {
    // 		fieldInput.classList.add("form__input--required");
    // 	} else {
    // 		fieldLabel.innerHTML = `${label} (<span class="form__label--optional">Optional <span class="form__label--optional-star">*</span></span>)`;
    // 	}
    // 	fieldInput.setAttribute("type", "text");
    // 	fieldInput.setAttribute("name", name);
    // 	fieldInput.setAttribute("placeholder", placeholder);
    // 	fieldContainer.appendChild(fieldLabel);
    // 	fieldContainer.appendChild(fieldInput);
    // 	container.insertBefore(fieldContainer, fieldBefore);
    // }
    FormItemInsurancePersonalServicePlanForm.prototype.servicingRequest = function (value) {
        switch (value) {
            case "HOP - Hollard Personal Lines":
            case "TUC - SIL Topup (ACB)":
            case "TUP - SIL Touch-up":
            case "STN - SBVAF":
            case "STH - Stansure":
            case "KPI - King Price Insurance":
            case "SHS - Stansure Select":
            case "SAU - SAU":
            case "SRA - Standard Road Accident Top-Up":
            case "ELS - Elite Sure - SAU Broker":
            case "ELS - Elite Sure - SAU Conversion":
            case "STB - Stansure Blue":
            case "FFW - First For Woman":
            case "SAU - Elite Sure":
                this.recipientInput.value = "sbibservices@standardbank.co.za";
                this.emailInput.value = "sbibservices@standardbank.co.za";
                break;
            case "MTF - Motorfleet":
                this.recipientInput.value = "Groupmotorclaims@standardbank.co.za";
                this.emailInput.value = "Groupmotorclaims@standardbank.co.za";
                break;
            case "SIL - SIL Direct":
                this.recipientInput.value = "SIL.INFO@STANDARDBANK.CO.ZA";
                this.emailInput.value = "SIL.INFO@STANDARDBANK.CO.ZA";
                break;
            case "SHL - Liberty Short Term":
                this.recipientInput.value = "info.libertyshort@liberty.co.za";
                this.emailInput.value = "info.libertyshort@liberty.co.za";
                break;
            case "HLB - Homeloans":
            case "HLC - Homeloans ACB":
            case "BMB - Business Mortgage":
            case "EBK - Low Income - group":
                this.recipientInput.value = "Silpolicy.admin@standardbank.co.za";
                this.emailInput.value = "Silpolicy.admin@standardbank.co.za";
                break;
            case "OWN - Own Arrangements":
                this.recipientInput.value = "Omins@standardbank.co.za";
                this.emailInput.value = "Omins@standardbank.co.za";
                break;
            case "AAP - Access Account Plus":
            case "FCB - Funeral Community Banking":
            case "FNL - Funeral Lite":
            case "FNR - Funeral":
            case "TMA/FMA - Flexible funeral policy on Mobility":
            case "ELP - E Plan":
            case "FUN - Flexi funeral on Sapphire":
                this.recipientInput.value = "assurancedivisionadmin@standardbank.co.za";
                this.emailInput.value = "assurancedivisionadmin@standardbank.co.za";
                break;
            case "BRS - Burial Society":
            case "EPP - Employee Protection Plan":
            case "GRP - Group Schemes funeral policy":
                this.recipientInput.value = "funeralgroupscheme@standardbank.co.za";
                this.emailInput.value = "funeralgroupscheme@standardbank.co.za";
                break;
            case "LVL - Level Life":
            case "HLP - Home Loan Protection":
                this.recipientInput.value = "sbib.creditlife@standardbank.co.za";
                this.emailInput.value = "sbib.creditlife@standardbank.co.za";
                break;
            case "CHL - Credit Life policies":
                this.recipientInput.value = "sbsa.travelinsurance@brytesa.com";
                this.emailInput.value = "sbsa.travelinsurance@brytesa.com";
                break;
            case "MDR - Personal Accident and Hospital":
                this.recipientInput.value = "SBIBMDR@standardbank.co.za";
                this.emailInput.value = "SBIBMDR@standardbank.co.za";
                break;
            case "MDR - Legal Assist":
                this.recipientInput.value = "sbibservices@standardbank.co.za";
                this.emailInput.value = "sbibservices@standardbank.co.za";
                break;
            case "BCI - Sectional Title":
            case "CPF - Bondsure":
            case "FAR - Farming":
            case "ENG - Engineering":
            case "COM - Commercial":
            case "BZS - Business Insurance":
            case "PSB/SBW - Non SILC Products":
                this.recipientInput.value = "CommercialInsurance@standardbank.co.za";
                this.emailInput.value = "CommercialInsurance@standardbank.co.za";
                break;
            default:
                this.recipientInput.value = "";
                this.emailInput.value = "";
        }
    };
    FormItemInsurancePersonalServicePlanForm.prototype.claimsRequest = function (value) {
        switch (value) {
            case "HOP - Hollard Personal Lines":
            case "KPI - King Price Insurance":
            case "SAU - SAU":
            case "TUP - SIL Touch-up":
            case "SRA - Standard Road Accident Top-Up":
            case "ELS - Elite Sure - SAU Broker":
            case "ELS - Elite Sure - SAU Conversion":
            case "FFW - First For Woman":
            case "SAU - Elite Sure":
                this.recipientInput.value = "sbibservices@standardbank.co.za";
                this.emailInput.value = "sbibservices@standardbank.co.za";
                break;
            case "TUC - SIL Topup (ACB)":
                this.recipientInput.value = "SILTopUp.Claims@standardbank.co.za";
                this.emailInput.value = "SILTopUp.Claims@standardbank.co.za";
                break;
            case "MTF - Motorfleet":
                this.recipientInput.value = "Groupmotorclaims@standardbank.co.za";
                this.emailInput.value = "Groupmotorclaims@standardbank.co.za";
                break;
            case "STN - SBVAF":
            case "STH - Stansure":
            case "SHS - Stansure Select":
            case "STB - Stansure Blue":
                this.recipientInput.value = "stansureclient@standardbank.co.za";
                this.emailInput.value = "stansureclient@standardbank.co.za";
                break;
            case "SIL - SIL Direct":
                this.recipientInput.value = "sil.info@standardbank.co.za";
                this.emailInput.value = "sil.info@standardbank.co.za";
                break;
            case "SHL - Liberty Short Term":
                this.recipientInput.value = "Claims.libertyshort@standardbank.co.za";
                this.emailInput.value = "Claims.libertyshort@standardbank.co.za";
                break;
            case "HLB - Homeloans":
            case "HLC - Homeloans ACB":
            case "BMB - Business Mortgage":
            case "EBK - Low Income - group":
                this.recipientInput.value = "hocclaims@standardbank.co.za";
                this.emailInput.value = "hocclaims@standardbank.co.za";
                break;
            case "AAP - Access Account Plus":
            case "BRS - Burial Society":
            case "FCB - Funeral Community Banking":
            case "EPP - Employee Protection Plan":
            case "FNL - Funeral Lite":
            case "FNR - Funeral":
            case "TMA/FMA - Flexible funeral policy on Mobility":
            case "GRP - Group Schemes funeral policy":
            case "ELP - E Plan":
            case "FUN - Flexi funeral on Sapphire":
            case "LVL - Level Life":
            case "CHL - Credit Life policies":
            case "HLP - Home Loan Protection":
                this.recipientInput.value = "SBIBClaimsEscalations@standardbank.co.za";
                this.emailInput.value = "SBIBClaimsEscalations@standardbank.co.za";
                break;
            case "CHL - Credit Life policies":
                this.recipientInput.value = "sbsa.travelinsurance@brytesa.com";
                this.emailInput.value = "sbsa.travelinsurance@brytesa.com";
                break;
            case "MDR - Personal Accident and Hospital":
                this.recipientInput.value = "SILMDRClaims@standardbank.co.za";
                this.emailInput.value = "SILMDRClaims@standardbank.co.za";
                break;
            case "MDR - Legal Assist":
                this.recipientInput.value = "SIL.LegalAssist@standardbank.co.za";
                this.emailInput.value = "SIL.LegalAssist@standardbank.co.za";
                break;
            case "BCI - Sectional Title":
            case "CPF - Bondsure":
            case "FAR - Farming":
            case "ENG - Engineering":
            case "COM - Commercial":
            case "BZS - Business Insurance":
                this.recipientInput.value = "silcclaims@standardbank.co.za";
                this.emailInput.value = "silcclaims@standardbank.co.za";
                break;
            case "PSB/SBW - Non SILC Products":
                this.recipientInput.value = "CommercialInsurance@standardbank.co.za";
                this.emailInput.value = "CommercialInsurance@standardbank.co.za";
                break;
            default:
                this.recipientInput.value = "";
                this.emailInput.value = "";
        }
    };
    FormItemInsurancePersonalServicePlanForm.prototype.salesRequest = function (value) {
        if (value === "MVW") {
            return "SBDirectMarketing@innovation.group";
        }
        else if (value === "PAC") {
            return "MDR.SBIBMDR@standardbank.co.za";
        }
        else if (value === "TRI") {
            return "sbsa.travelinsurance@brytesa.com";
        }
        else if (value === "LAP") {
            return "MDR.SBIBMDR@standardbank.co.za";
        }
        else {
            return "";
        }
    };
    FormItemInsurancePersonalServicePlanForm.prototype.submitForm = function (form) {
        var _productTypeLSID = form.querySelector("select[name=product-type]");
        var _productTypeHiddenLSID = form.querySelector("input[name=product-type-hidden]");
        var productLSID = "";
        if (_productTypeLSID) {
            productLSID = _productTypeLSID.value;
        }
        else {
            if (_productTypeHiddenLSID) {
                productLSID = _productTypeHiddenLSID.value;
            }
        }
        if (this.showVehicleWarreties) {
            this.showVehicleWarreties.classList.add("form__group--hidden");
        }
        if (this.queryType) {
            if (this.queryType === "servicingRequest" ||
                this.queryType === "claimsRequest") {
                if (productLSID === "MVW") {
                    this.submitCarWarrantiesRequestForm(form);
                }
                else {
                    this.submitRequestRequest(form);
                }
            }
            else {
                if (productLSID === "MVW") {
                    this.submitCarWarrantiesQuoteForm(form);
                }
                else {
                    this.submitQuoteForm(form);
                }
            }
        }
        else {
            if (productLSID === "MVW") {
                this.submitCarWarrantiesQuoteForm(form);
            }
            else {
                this.submitQuoteForm(form);
            }
        }
    };
    FormItemInsurancePersonalServicePlanForm.prototype.submitRequestRequest = function (form) {
        var _this = this;
        this.showDisplayView("loader");
        if (this.queryType) {
            if (this.queryType === "servicingRequest") {
                if (this.selectProductInterestedType) {
                    this.servicingRequest(this.productInterestedType);
                }
            }
            else if (this.queryType === "claimsRequest") {
                if (this.selectProductInterestedType) {
                    this.claimsRequest(this.productInterestedType);
                }
            }
        }
        var _firstName = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=last-name]");
        var _contactNumber = this.form.querySelector("input[name=phone-number]");
        var _confirmPhoneNumber = this.form.querySelector("input[name=confirm-phone-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _productInterestType = this.productInterestedType;
        var _policyNumber = this.form.querySelector("input[name=policy-number]");
        var _policyClaimNumber = this.form.querySelector("input[name=policy-claim-number]");
        var _popiaConsent = form.querySelector("input[name=popia-consent]");
        var _email = this.form.querySelector("input[name=email]");
        var _recipientInput = this.form.querySelector("input[name=recipient]");
        var _subjectInput = this.form.querySelector("input[name=subject]");
        var vehicleYearModel = this.form.querySelector("input[name=vehicle-year-model]");
        var vehicleMakeModel = this.form.querySelector("input[name=vehicle-make-model]");
        var vehicleEngineCapacity = this.form.querySelector("input[name=vehicle-engine-capacity]");
        var vehicleMileage = this.form.querySelector("input[name=vehicle-mileage]");
        var vehicleVinNumber = this.form.querySelector("input[name=vehicle-vinnumber]");
        var vahiclewarranties = this.element.querySelector(".vehicle-warranties");
        var insuranceProductName = _productInterestType;
        var emailSubject = "";
        // SUBJECT LINE
        if (this.queryType === "servicingRequest") {
            emailSubject = _subjectInput
                ? _subjectInput.value + " - Service Request"
                : _subjectInput.value;
        }
        else if (this.queryType === "claimsRequest") {
            emailSubject = _subjectInput
                ? _subjectInput.value + " - Claims Request"
                : _subjectInput.value;
        }
        else {
            emailSubject = "Standardbank.co.za Client Request - Quote Request";
            insuranceProductName = this.productName;
        }
        var postData = {
            email: _email ? _email.value : "",
            recipient: _recipientInput ? _recipientInput.value : "",
            subject: emailSubject,
            product: insuranceProductName,
            policyNumber: _policyNumber ? _policyNumber.value : "",
            policyClaimNumber: _policyClaimNumber
                ? _policyClaimNumber.value
                : "",
            first: _firstName ? _firstName.value : "",
            last: _surname ? _surname.value : "",
            cell: _contactNumber ? _contactNumber.value : "",
            confirmPhoneNumber: _confirmPhoneNumber
                ? _confirmPhoneNumber.value
                : "",
            emailAddress: _emailAddress ? _emailAddress.value : "",
            popiaConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataPrivacyConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-boarders"),
            dataSharingGroup: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharing3rdParty: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingBoarders: this.getDataConsentValue(form, "data-sharing-boarders"),
        };
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/leadsutils/createinsurance";
        var postDataConfig;
        var productcode = "warranties";
        var tyrerimwarranties = this.element.querySelector(".tyrerimwarranties");
        var choiceServicePlan = this.element.querySelector(".choiceServicePlan");
        if (tyrerimwarranties) {
            productcode = "tyrerimwarranties";
        }
        else if (choiceServicePlan) {
            productcode = "ChoiceServicePlan";
        }
        if (!this.queryType) {
            this.queryType = "quote";
        }
        if (vahiclewarranties && this.queryType === "quote") {
            var data = {
                firstName: _firstName ? _firstName.value : "",
                lastName: _surname ? _surname.value : "",
                phoneNumber: _contactNumber ? _contactNumber.value : "",
                emailAddress: _emailAddress ? _emailAddress.value : "",
                modal: vehicleYearModel.value,
                make: vehicleMakeModel.value,
                engineCapacity: parseFloat(vehicleEngineCapacity.value),
                mileage: vehicleMileage.value,
                vinNumber: vehicleVinNumber.value,
                product: productcode,
                dataPrivacyConsent: _popiaConsent
                    ? _popiaConsent.checked
                        ? "YES"
                        : "NO"
                    : "NO",
                dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-group"),
                dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(form, "data-sharing-3rd-party"),
                dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-boarders"),
            };
            url = "/leadsutils/creatigleads";
            postDataConfig = data;
        }
        else {
            postDataConfig = postData;
        }
        JSON.stringify(postDataConfig);
        var config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        // service
        this.formsService
            .postForm(url, postDataConfig, config)
            .then(function (response) {
            // Display success - sending email
            analyticsService.dtmFormComplete("complete", response.data, false, "", _emailAddress.value, _contactNumber.value);
            _this.showDisplayView("success");
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemInsurancePersonalServicePlanForm.prototype.submitQuoteForm = function (form) {
        var _this = this;
        this.showDisplayView("loader");
        var _firstName = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=last-name]");
        var _contactNumber = this.form.querySelector("input[name=phone-number]");
        var _confirmPhoneNumber = this.form.querySelector("input[name=confirm-phone-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _popiaConsent = form.querySelector("input[name=popia-consent]");
        var _productTypeLSID = form.querySelector("select[name=product-type]");
        var _productTypeHiddenLSID = form.querySelector("input[name=product-type-hidden]");
        var vehicleYearModel = this.form.querySelector("input[name=vehicle-year-model]");
        var vehicleMakeModel = this.form.querySelector("input[name=vehicle-make-model]");
        var vehicleEngineCapacity = this.form.querySelector("input[name=vehicle-engine-capacity]");
        var vehicleMileage = this.form.querySelector("input[name=vehicle-mileage]");
        var vehicleVinNumber = this.form.querySelector("input[name=vehicle-vinnumber]");
        var vahiclewarranties = this.element.querySelector(".vehicle-warranties");
        var _source = this.formsService.isMobile();
        var productLSID = "";
        if (_productTypeLSID) {
            productLSID = _productTypeLSID.value;
        }
        else {
            if (_productTypeHiddenLSID) {
                productLSID = _productTypeHiddenLSID.value;
            }
        }
        // variables
        var analyticsService = new AnalyticsService();
        // Custom quotes to be send via email if LSID does not match email list
        // const _email = this.salesRequest(productLSID);|
        // variables
        var postDataConfig;
        var data = {
            firstName: _firstName ? _firstName.value : "",
            lastName: _surname ? _surname.value : "",
            phoneNumber: _contactNumber ? _contactNumber.value : "",
            emailAddress: _emailAddress ? _emailAddress.value : "",
            modal: vehicleYearModel.value,
            make: vehicleMakeModel.value,
            engineCapacity: parseFloat(vehicleEngineCapacity.value),
            mileage: vehicleMileage.value,
            vinNumber: vehicleVinNumber.value,
            product: "ChoiceServicePlan",
            dataPrivacyConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-boarders"),
            recaptchaToken: this.gRecaptchaToken
        };
        var url = "/leadsutils/creatigleads";
        postDataConfig = data;
        var config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
        };
        JSON.stringify(postDataConfig);
        // service
        this.formsService
            .postForm(url, postDataConfig, config)
            .then(function (response) {
            // Display success - sending email
            if (response.data && response.data.captchaResponse === false) {
                _this.displayLoader.classList.remove("active");
                _this.displayFields.classList.remove("hidden");
            }
            else {
                analyticsService.dtmFormComplete("complete", response.data, false, "", _emailAddress.value, _contactNumber.value);
                _this.showDisplayView("success");
            }
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemInsurancePersonalServicePlanForm.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemInsurancePersonalServicePlanForm.prototype.submitCarWarrantiesRequestForm = function (form) {
        var _this = this;
        this.showDisplayView("loader");
        this.recipientInput.value = "standardbankqueries@innovation.group";
        this.emailInput.value = "standardbankqueries@innovation.group";
        var _firstName = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=last-name]");
        var _contactNumber = this.form.querySelector("input[name=phone-number]");
        var _confirmPhoneNumber = this.form.querySelector("input[name=confirm-phone-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _productInterestType = this.productInterestedType;
        var _policyNumber = this.form.querySelector("input[name=policy-number]");
        var _policyClaimNumber = this.form.querySelector("input[name=policy-claim-number]");
        var _popiaConsent = form.querySelector("input[name=popia-consent]");
        var _email = this.form.querySelector("input[name=email]");
        var _recipientInput = this.form.querySelector("input[name=recipient]");
        var _subjectInput = this.form.querySelector("input[name=subject]");
        var vehicleYearModel = this.form.querySelector("input[name=vehicle-year-model]");
        var vehicleMakeModel = this.form.querySelector("input[name=vehicle-make-model]");
        var vehicleEngineCapacity = this.form.querySelector("input[name=vehicle-engine-capacity]");
        var vehicleMileage = this.form.querySelector("input[name=vehicle-mileage]");
        var vehicleVinNumber = this.form.querySelector("input[name=vehicle-vinnumber]");
        var vahiclewarranties = this.element.querySelector(".vehicle-warranties");
        var insuranceProductName = this.productName;
        var emailSubject = "";
        // SUBJECT LINE
        if (this.queryType === "servicingRequest") {
            emailSubject = _subjectInput
                ? _subjectInput.value + " - Service Request"
                : _subjectInput.value;
        }
        else if (this.queryType === "claimsRequest") {
            emailSubject = _subjectInput
                ? _subjectInput.value + " - Claims Request"
                : _subjectInput.value;
        }
        else {
            emailSubject = "Standardbank.co.za Client Request - Quote Request";
        }
        var postData = {
            email: _email ? _email.value : "",
            recipient: _recipientInput ? _recipientInput.value : "",
            subject: emailSubject,
            product: insuranceProductName,
            query: _productInterestType ? _productInterestType : "",
            policyNumber: _policyNumber ? _policyNumber.value : "",
            policyClaimNumber: _policyClaimNumber
                ? _policyClaimNumber.value
                : "",
            popiaConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            first: _firstName ? _firstName.value : "",
            last: _surname ? _surname.value : "",
            cell: _contactNumber ? _contactNumber.value : "",
            confirmPhoneNumber: _confirmPhoneNumber
                ? _confirmPhoneNumber.value
                : "",
            emailAddress: _emailAddress ? _emailAddress.value : "",
            dataPrivacyConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-boarders"),
            dataSharingGroup: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharing3rdParty: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingBoarders: this.getDataConsentValue(form, "data-sharing-boarders"),
        };
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/leadsutils/createinsurance";
        var postDataConfig;
        var productcode = "warranties";
        var tyrerimwarranties = this.element.querySelector(".tyrerimwarranties");
        var choiceServicePlan = this.element.querySelector(".choiceServicePlan");
        if (tyrerimwarranties) {
            productcode = "tyrerimwarranties";
        }
        else if (choiceServicePlan) {
            productcode = "ChoiceServicePlan";
        }
        if (!this.queryType) {
            this.queryType = "quote";
        }
        if (vahiclewarranties && this.queryType === "quote") {
            var data = {
                firstName: _firstName ? _firstName.value : "",
                lastName: _surname ? _surname.value : "",
                phoneNumber: _contactNumber ? _contactNumber.value : "",
                emailAddress: _emailAddress ? _emailAddress.value : "",
                modal: vehicleYearModel.value,
                make: vehicleMakeModel.value,
                engineCapacity: parseFloat(vehicleEngineCapacity.value),
                mileage: vehicleMileage.value,
                vinNumber: vehicleVinNumber.value,
                product: productcode,
                dataPrivacyConsent: _popiaConsent
                    ? _popiaConsent.checked
                        ? "YES"
                        : "NO"
                    : "NO",
                dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-group"),
                dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(form, "data-sharing-3rd-party"),
                dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-boarders"),
            };
            url = "/leadsutils/creatigleads";
            postDataConfig = data;
        }
        else {
            postDataConfig = postData;
        }
        var config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
        };
        JSON.stringify(postDataConfig);
        // service
        this.formsService
            .postForm(url, postDataConfig, config)
            .then(function (response) {
            // Display success - sending email
            analyticsService.dtmFormComplete("complete", response.data, false, "", _emailAddress.value, _contactNumber.value);
            _this.showDisplayView("success");
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemInsurancePersonalServicePlanForm.prototype.submitCarWarrantiesQuoteForm = function (form) {
        var _this = this;
        this.showDisplayView("loader");
        this.recipientInput.value = "SBDirectMarketing@innovation.group";
        this.emailInput.value = "SBDirectMarketing@innovation.group";
        var _firstName = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=last-name]");
        var _contactNumber = this.form.querySelector("input[name=phone-number]");
        var _confirmPhoneNumber = this.form.querySelector("input[name=confirm-phone-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _quoteProductInterestType = this.form.querySelector("select[name=quote-product]");
        var _popiaConsent = form.querySelector("input[name=popia-consent]");
        var _email = this.form.querySelector("input[name=email]");
        var _recipientInput = this.form.querySelector("input[name=recipient]");
        var vehicleYearModel = this.form.querySelector("input[name=vehicle-year-model]");
        var vehicleMakeModel = this.form.querySelector("input[name=vehicle-make-model]");
        var vehicleEngineCapacity = this.form.querySelector("input[name=vehicle-engine-capacity]");
        var vehicleMileage = this.form.querySelector("input[name=vehicle-mileage]");
        var vehicleVinNumber = this.form.querySelector("input[name=vehicle-vinnumber]");
        var vahiclewarranties = this.element.querySelector(".vehicle-warranties");
        var tyrerimwarranties = this.element.querySelector(".tyrerimwarranties");
        var choiceServicePlan = this.element.querySelector(".choiceServicePlan");
        var insuranceProductName = this.productName;
        var emailSubject = "";
        // SUBJECT LINE
        emailSubject = "Standardbank.co.za Client Request - Quote Request";
        var postData = {
            email: _email ? _email.value : "",
            recipient: _recipientInput ? _recipientInput.value : "",
            subject: emailSubject,
            product: insuranceProductName,
            query: _quoteProductInterestType
                ? _quoteProductInterestType.value
                : "",
            first: _firstName ? _firstName.value : "",
            last: _surname ? _surname.value : "",
            cell: _contactNumber ? _contactNumber.value : "",
            confirmPhoneNumber: _confirmPhoneNumber
                ? _confirmPhoneNumber.value
                : "",
            emailAddress: _emailAddress ? _emailAddress.value : "",
            popiaConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataPrivacyConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-boarders"),
            dataSharingGroup: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharing3rdParty: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingBoarders: this.getDataConsentValue(form, "data-sharing-boarders"),
            recaptchaToken: this.gRecaptchaToken
        };
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/leadsutils/createinsurance";
        var postDataConfig;
        var productcode = "warranties";
        if (tyrerimwarranties) {
            productcode = "tyrerimwarranties";
        }
        else if (choiceServicePlan) {
            productcode = "ChoiceServicePlan";
        }
        if (!this.queryType) {
            this.queryType = "quote";
        }
        if (vahiclewarranties && this.queryType === "quote") {
            var data = {
                firstName: _firstName ? _firstName.value : "",
                lastName: _surname ? _surname.value : "",
                phoneNumber: _contactNumber ? _contactNumber.value : "",
                emailAddress: _emailAddress ? _emailAddress.value : "",
                modal: vehicleYearModel.value,
                make: vehicleMakeModel.value,
                engineCapacity: parseFloat(vehicleEngineCapacity.value),
                mileage: vehicleMileage.value,
                vinNumber: vehicleVinNumber.value,
                product: productcode,
                dataPrivacyConsent: _popiaConsent
                    ? _popiaConsent.checked
                        ? "YES"
                        : "NO"
                    : "NO",
                dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-group"),
                dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(form, "data-sharing-3rd-party"),
                dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-boarders"),
            };
            url = "/leadsutils/creatigleads";
            postDataConfig = data;
        }
        else {
            postDataConfig = postData;
        }
        var config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
        };
        JSON.stringify(postDataConfig);
        // service
        this.formsService
            .postForm(url, postDataConfig, config)
            .then(function (response) {
            // Display success - sending email
            analyticsService.dtmFormComplete("complete", response.data, false, "", _emailAddress.value, _contactNumber.value);
            _this.showDisplayView("success");
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemInsurancePersonalServicePlanForm.prototype.createBlankOption = function () {
        var elem = document.createElement("option");
        elem.textContent = "Select product";
        elem.value = "";
        return elem;
    };
    FormItemInsurancePersonalServicePlanForm.prototype.createOption = function (pData) {
        var elem = document.createElement("option");
        elem.textContent = pData.name;
        elem.value = pData.value;
        return elem;
    };
    FormItemInsurancePersonalServicePlanForm.prototype.resetForm = function () {
        var fieldContainer = this.form.querySelector("div.form-container__fields");
        var fieldClaimNumbers = fieldContainer.querySelectorAll("div.form__group--claim-number");
        if (fieldClaimNumbers) {
            fieldClaimNumbers.forEach(function (element) {
                fieldContainer.removeChild(element);
            });
        }
        if (this.selectProductInterestedTypeContainer) {
            this.selectProductInterestedTypeContainer.classList.add("form__group--hidden");
        }
        this.showDisplayView("");
    };
    FormItemInsurancePersonalServicePlanForm.prototype.getProductName = function (_productCategoryValue, _productSubCategoryValue) {
        if (_productCategoryValue === "car") {
            switch (_productSubCategoryValue) {
                case "Insurance":
                    return "Car Insurance - Insurance";
                case "CarAndHome":
                    return "Car Insurance - Car and Home";
                case "Warranties":
                    return "Car Insurance - Warranties";
                case "DentAndScratch":
                    return "Car Insurance - Dent and Scratch";
                default:
                    return "Car Insurance";
            }
        }
        else if (_productCategoryValue === "home") {
            switch (_productSubCategoryValue) {
                case "HomeContents":
                    return "Home Insurance - Home Contents";
                case "BuildingInsurance":
                    return "Home Insurance - Building Insurance";
                default:
                    return "Home Insurance";
            }
        }
        else if (_productCategoryValue === "income") {
            switch (_productSubCategoryValue) {
                case "SalaryProtection":
                    return "Income Insurance - Salary Protection";
                case "DisabilityCover":
                    return "Income Insurance - Disability Cover";
                case "SeriousIllnessCover":
                    return "Income Insurance - Serious Illness Cover";
                default:
                    return "Income Insurance";
            }
        }
        else if (_productCategoryValue === "yourself") {
            switch (_productSubCategoryValue) {
                case "FFP":
                    return "Personal Insurance - Flexible Funeral Plan";
                case "FFPHouseholdStaff":
                    return "Personal Insurance - Flexible Funeral Plan Household Staff";
                case "FFPExtendedFamily":
                    return "Personal Insurance - Flexible Funeral Plan Extended Family";
                case "FFPLifeCoverMadeSimple":
                    return "Personal Insurance - Flexible Funeral Plan Life Cover Made Simple";
                case "PersonalAccidentPlan":
                    return "Personal Insurance - Personal Accident Plan";
                case "TravelInsurance":
                    return "Personal Insurance - Travel Insurance";
                case "LegalAssist":
                    return "Personal Insurance - Legal Assist";
                default:
                    return "Personal Insurance";
            }
        }
        else if (_productCategoryValue === "debt") {
            switch (_productSubCategoryValue) {
                case "CreditCard":
                    return "Debt Insurance - Credit Card";
                case "Loans":
                    return "Debt Insurance - Loans";
                case "CarFinanceShortfall":
                    return "Debt Insurance - Car Finance Shortfall";
                case "CarFinanceProtection":
                    return "Debt Insurance - Car Finance Protection";
                case "HomeLoanProtection":
                    return "Debt Insurance - Home Loan Protection";
                default:
                    return "Debt Insurance";
            }
        }
        else if (_productCategoryValue === "commercial") {
            switch (_productSubCategoryValue) {
                case "SectionalTitle":
                    return "Commercial Insurance - Sectional Title";
                case "Bondsure":
                    return "Commercial Insurance - Bondsure";
                case "Farming":
                    return "Commercial Insurance - Farming";
                case "Engineering":
                    return "Commercial Insurance - Engineering";
                case "Commercial":
                    return "Commercial Insurance - Commercial";
                case "BusinessInsurance":
                    return "Commercial Insurance - Business Insurance";
                case "NonSILCProducts":
                    return "Commercial Insurance - Non SILC Products";
                default:
                    return "Commercial Insurance";
            }
        }
        else {
            return "Insurance Quote";
        }
    };
    FormItemInsurancePersonalServicePlanForm.prototype.populateProducts = function (_productCategoryValue, _productSubCategoryValue) {
        var insuranceProducts = [];
        var numberOfProducts = 0;
        if (_productCategoryValue === "car") {
            insuranceProducts = this.getCarInsuranceProducts(_productSubCategoryValue);
        }
        else if (_productCategoryValue === "home") {
            insuranceProducts = this.getHomeInsuranceProducts(_productSubCategoryValue);
        }
        else if (_productCategoryValue === "income") {
            insuranceProducts = this.getIncomeInsuranceProducts(_productSubCategoryValue);
        }
        else if (_productCategoryValue === "yourself") {
            insuranceProducts = this.getYourselfInsuranceProducts(_productSubCategoryValue);
        }
        else if (_productCategoryValue === "debt") {
            insuranceProducts = this.getDebtInsuranceProducts(_productSubCategoryValue);
        }
        else if (_productCategoryValue === "commercial") {
            insuranceProducts = this.getCommercialInsuranceProducts(_productSubCategoryValue);
        }
        else {
            insuranceProducts = this.getAllInsuranceProducts();
        }
        if (insuranceProducts.length > 0) {
            numberOfProducts = insuranceProducts.length;
            if (numberOfProducts === 1) {
                this.productInterestedTypeNoSelection(insuranceProducts[0].value);
            }
            else {
                var blankProductOption = this.createBlankOption();
                this.selectProductInterestedType.innerHTML = "";
                this.selectProductInterestedType.appendChild(blankProductOption);
                for (var i = 0; i < insuranceProducts.length; i++) {
                    var productOption = this.createOption(insuranceProducts[i]);
                    this.selectProductInterestedType.appendChild(productOption);
                }
            }
        }
        return numberOfProducts;
    };
    // Car Insurance Products
    FormItemInsurancePersonalServicePlanForm.prototype.getCarInsuranceProducts = function (subCategory) {
        switch (subCategory) {
            case "Insurance":
                return [
                    {
                        name: "Hollard Personal Lines",
                        value: "HOP - Hollard Personal Lines",
                    },
                    { name: "SIL Topup (ACB)", value: "TUC - SIL Topup (ACB)" },
                    { name: "SIL Touch-up", value: "TUP - SIL Touch-up" },
                    { name: "SBVAF", value: "STN - SBVAF" },
                    { name: "Stansure", value: "STH - Stansure" },
                    { name: "Motorfleet", value: "MTF - Motorfleet" },
                    {
                        name: "King Price Insurance",
                        value: "KPI - King Price Insurance",
                    },
                    { name: "Stansure Select", value: "SHS - Stansure Select" },
                    { name: "SAU", value: "SAU - SAU" },
                    {
                        name: "Standard Road Accident Top-Up",
                        value: "SRA - Standard Road Accident Top-Up",
                    },
                    {
                        name: "Elite Sure - SAU Broker",
                        value: "ELS - Elite Sure - SAU Broker",
                    },
                    {
                        name: "Elite Sure - SAU Conversion",
                        value: "ELS - Elite Sure - SAU Conversion",
                    },
                    { name: "Stansure Blue", value: "STB - Stansure Blue" },
                    { name: "First For Woman", value: "FFW - First For Woman" },
                    { name: "Elite Sure", value: "SAU - Elite Sure" },
                    { name: "SIL Direct", value: "SIL - SIL Direct" },
                    {
                        name: "Liberty Short Term",
                        value: "SHL - Liberty Short Term",
                    },
                ];
            case "CarAndHome":
                return [
                    {
                        name: "Hollard Personal Lines",
                        value: "HOP - Hollard Personal Lines",
                    },
                    { name: "SIL Topup (ACB)", value: "TUC - SIL Topup (ACB)" },
                    { name: "SIL Touch-up", value: "TUP - SIL Touch-up" },
                    { name: "SBVAF", value: "STN - SBVAF" },
                    { name: "Stansure", value: "STH - Stansure" },
                    { name: "Motorfleet", value: "MTF - Motorfleet" },
                    {
                        name: "King Price Insurance",
                        value: "KPI - King Price Insurance",
                    },
                    { name: "Stansure Select", value: "SHS - Stansure Select" },
                    { name: "SAU", value: "SAU - SAU" },
                    {
                        name: "Standard Road Accident Top-Up",
                        value: "SRA - Standard Road Accident Top-Up",
                    },
                    {
                        name: "Elite Sure - SAU Broker",
                        value: "ELS - Elite Sure - SAU Broker",
                    },
                    {
                        name: "Elite Sure - SAU Conversion",
                        value: "ELS - Elite Sure - SAU Conversion",
                    },
                    { name: "Stansure Blue", value: "STB - Stansure Blue" },
                    { name: "First For Woman", value: "FFW - First For Woman" },
                    { name: "Elite Sure", value: "SAU - Elite Sure" },
                    { name: "SIL Direct", value: "SIL - SIL Direct" },
                    {
                        name: "Liberty Short Term",
                        value: "SHL - Liberty Short Term",
                    },
                ];
            case "Warranties":
                return [
                    {
                        name: "Extended Vehicle Warranty",
                        value: "Extended Vehicle Warranty",
                    },
                    {
                        name: "Pre-owned Vehicle Warranty",
                        value: "Pre-owned Vehicle Warranty",
                    },
                ];
            case "DentAndScratch":
                return [{ name: "SIL Touch-up", value: "TUP - SIL Touch-up" }];
            // Return All Products
            default:
                return [
                    {
                        name: "Hollard Personal Lines",
                        value: "HOP - Hollard Personal Lines",
                    },
                    { name: "SIL Topup (ACB)", value: "TUC - SIL Topup (ACB)" },
                    { name: "SIL Touch-up", value: "TUP - SIL Touch-up" },
                    { name: "SBVAF", value: "STN - SBVAF" },
                    { name: "Stansure", value: "STH - Stansure" },
                    { name: "Motorfleet", value: "MTF - Motorfleet" },
                    {
                        name: "King Price Insurance",
                        value: "KPI - King Price Insurance",
                    },
                    { name: "Stansure Select", value: "SHS - Stansure Select" },
                    { name: "SAU", value: "SAU - SAU" },
                    {
                        name: "Standard Road Accident Top-Up",
                        value: "SRA - Standard Road Accident Top-Up",
                    },
                    {
                        name: "Elite Sure - SAU Broker",
                        value: "ELS - Elite Sure - SAU Broker",
                    },
                    {
                        name: "Elite Sure - SAU Conversion",
                        value: "ELS - Elite Sure - SAU Conversion",
                    },
                    { name: "Stansure Blue", value: "STB - Stansure Blue" },
                    { name: "First For Woman", value: "FFW - First For Woman" },
                    { name: "Elite Sure", value: "SAU - Elite Sure" },
                    { name: "SIL Direct", value: "SIL - SIL Direct" },
                    {
                        name: "Liberty Short Term",
                        value: "SHL - Liberty Short Term",
                    },
                ];
        }
    };
    // Home Insurance Products
    FormItemInsurancePersonalServicePlanForm.prototype.getHomeInsuranceProducts = function (subCategory) {
        switch (subCategory) {
            case "HomeContents":
                return [
                    { name: "Homeloans", value: "HLB - Homeloans" },
                    {
                        name: "Own Arrangements",
                        value: "OWN - Own Arrangements",
                    },
                    { name: "Homeloans ACB", value: "HLC - Homeloans ACB" },
                    {
                        name: "Business Mortgage",
                        value: "BMB - Business Mortgage",
                    },
                    {
                        name: "Low Income - group",
                        value: "EBK - Low Income - group",
                    },
                    { name: "SIL Direct", value: "SIL - SIL Direct" },
                    {
                        name: "Liberty Short Term",
                        value: "SHL - Liberty Short Term",
                    },
                    {
                        name: "Hollard Personal Lines",
                        value: "HOP - Hollard Personal Lines",
                    },
                    { name: "Stansure", value: "STH - Stansure" },
                    {
                        name: "King Price Insurance",
                        value: "KPI - King Price Insurance",
                    },
                    { name: "Stansure Select", value: "SHS - Stansure Select" },
                    { name: "SAU", value: "SAU - SAU" },
                    { name: "Stansure Blue", value: "STB - Stansure Blue" },
                    { name: "First For Woman", value: "FFW - First For Woman" },
                    { name: "Elite Sure", value: "SAU - Elite Sure" },
                ];
            case "BuildingInsurance":
                return [
                    { name: "Homeloans", value: "HLB - Homeloans" },
                    {
                        name: "Own Arrangements",
                        value: "OWN - Own Arrangements",
                    },
                    { name: "Homeloans ACB", value: "HLC - Homeloans ACB" },
                    {
                        name: "Business Mortgage",
                        value: "BMB - Business Mortgage",
                    },
                    {
                        name: "Low Income - group",
                        value: "EBK - Low Income - group",
                    },
                    { name: "SIL Direct", value: "SIL - SIL Direct" },
                    {
                        name: "Liberty Short Term",
                        value: "SHL - Liberty Short Term",
                    },
                    {
                        name: "Hollard Personal Lines",
                        value: "HOP - Hollard Personal Lines",
                    },
                    { name: "Stansure", value: "STH - Stansure" },
                    {
                        name: "King Price Insurance",
                        value: "KPI - King Price Insurance",
                    },
                    { name: "Stansure Select", value: "SHS - Stansure Select" },
                    { name: "SAU", value: "SAU - SAU" },
                    { name: "Stansure Blue", value: "STB - Stansure Blue" },
                    { name: "First For Woman", value: "FFW - First For Woman" },
                    { name: "Elite Sure", value: "SAU - Elite Sure" },
                ];
            // Return All Products
            default:
                return [
                    { name: "Homeloans", value: "HLB - Homeloans" },
                    {
                        name: "Own Arrangements",
                        value: "OWN - Own Arrangements",
                    },
                    { name: "Homeloans ACB", value: "HLC - Homeloans ACB" },
                    {
                        name: "Business Mortgage",
                        value: "BMB - Business Mortgage",
                    },
                    {
                        name: "Low Income - group",
                        value: "EBK - Low Income - group",
                    },
                    { name: "SIL Direct", value: "SIL - SIL Direct" },
                    {
                        name: "Liberty Short Term",
                        value: "SHL - Liberty Short Term",
                    },
                    {
                        name: "Hollard Personal Lines",
                        value: "HOP - Hollard Personal Lines",
                    },
                    { name: "Stansure", value: "STH - Stansure" },
                    {
                        name: "King Price Insurance",
                        value: "KPI - King Price Insurance",
                    },
                    { name: "Stansure Select", value: "SHS - Stansure Select" },
                    { name: "SAU", value: "SAU - SAU" },
                    { name: "Stansure Blue", value: "STB - Stansure Blue" },
                    { name: "First For Woman", value: "FFW - First For Woman" },
                    { name: "Elite Sure", value: "SAU - Elite Sure" },
                ];
        }
    };
    // Income Insurance Products
    FormItemInsurancePersonalServicePlanForm.prototype.getIncomeInsuranceProducts = function (subCategory) {
        switch (subCategory) {
            case "SalaryProtection":
                return [
                    {
                        name: "Access Account Plus",
                        value: "AAP - Access Account Plus",
                    },
                    { name: "Burial Society", value: "BRS - Burial Society" },
                    {
                        name: "Funeral Community Banking",
                        value: "FCB - Funeral Community Banking",
                    },
                ];
            case "DisabilityCover":
                return [
                    {
                        name: "Access Account Plus",
                        value: "AAP - Access Account Plus",
                    },
                    { name: "Burial Society", value: "BRS - Burial Society" },
                    {
                        name: "Funeral Community Banking",
                        value: "FCB - Funeral Community Banking",
                    },
                ];
            case "SeriousIllnessCover":
                return [
                    {
                        name: "Access Account Plus",
                        value: "AAP - Access Account Plus",
                    },
                    { name: "Burial Society", value: "BRS - Burial Society" },
                    {
                        name: "Funeral Community Banking",
                        value: "FCB - Funeral Community Banking",
                    },
                ];
            // Return All Products
            default:
                return [
                    {
                        name: "Access Account Plus",
                        value: "AAP - Access Account Plus",
                    },
                    { name: "Burial Society", value: "BRS - Burial Society" },
                    {
                        name: "Funeral Community Banking",
                        value: "FCB - Funeral Community Banking",
                    },
                ];
        }
    };
    // Yourself Insurance Products
    FormItemInsurancePersonalServicePlanForm.prototype.getYourselfInsuranceProducts = function (subCategory) {
        switch (subCategory) {
            case "FFP":
                return [
                    {
                        name: "Employee Protection Plan",
                        value: "EPP - Employee Protection Plan",
                    },
                    { name: "Funeral Lite", value: "FNL - Funeral Lite" },
                    { name: "Funeral", value: "FNR - Funeral" },
                    {
                        name: "Flexible funeral policy on Mobility",
                        value: "TMA/FMA - Flexible funeral policy on Mobility",
                    },
                    {
                        name: "Personal Accident and Hospital",
                        value: "MDR - Personal Accident and Hospital",
                    },
                    {
                        name: "Credit Life policies",
                        value: "CHL - Credit Life policies",
                    },
                    { name: "Legal Assist", value: "MDR - Legal Assist" },
                    { name: "E Plan", value: "ELP - E Plan" },
                    {
                        name: "Flexi funeral on Sapphire",
                        value: "FUN - Flexi funeral on Sapphire",
                    },
                ];
            case "FFPHouseholdStaff":
                return [
                    {
                        name: "Employee Protection Plan",
                        value: "EPP - Employee Protection Plan",
                    },
                    { name: "Funeral Lite", value: "FNL - Funeral Lite" },
                    { name: "Funeral", value: "FNR - Funeral" },
                    {
                        name: "Flexible funeral policy on Mobility",
                        value: "TMA/FMA - Flexible funeral policy on Mobility",
                    },
                    {
                        name: "Personal Accident and Hospital",
                        value: "MDR - Personal Accident and Hospital",
                    },
                    {
                        name: "Credit Life policies",
                        value: "CHL - Credit Life policies",
                    },
                    { name: "Legal Assist", value: "MDR - Legal Assist" },
                    { name: "E Plan", value: "ELP - E Plan" },
                    {
                        name: "Flexi funeral on Sapphire",
                        value: "FUN - Flexi funeral on Sapphire",
                    },
                ];
            case "FFPExtendedFamily":
                return [
                    {
                        name: "Employee Protection Plan",
                        value: "EPP - Employee Protection Plan",
                    },
                    { name: "Funeral Lite", value: "FNL - Funeral Lite" },
                    { name: "Funeral", value: "FNR - Funeral" },
                    {
                        name: "Flexible funeral policy on Mobility",
                        value: "TMA/FMA - Flexible funeral policy on Mobility",
                    },
                    {
                        name: "Personal Accident and Hospital",
                        value: "MDR - Personal Accident and Hospital",
                    },
                    {
                        name: "Credit Life policies",
                        value: "CHL - Credit Life policies",
                    },
                    { name: "Legal Assist", value: "MDR - Legal Assist" },
                    { name: "E Plan", value: "ELP - E Plan" },
                    {
                        name: "Flexi funeral on Sapphire",
                        value: "FUN - Flexi funeral on Sapphire",
                    },
                ];
            case "FFPLifeCoverMadeSimple":
                return [
                    {
                        name: "Employee Protection Plan",
                        value: "EPP - Employee Protection Plan",
                    },
                    { name: "Funeral Lite", value: "FNL - Funeral Lite" },
                    { name: "Funeral", value: "FNR - Funeral" },
                    {
                        name: "Flexible funeral policy on Mobility",
                        value: "TMA/FMA - Flexible funeral policy on Mobility",
                    },
                    {
                        name: "Personal Accident and Hospital",
                        value: "MDR - Personal Accident and Hospital",
                    },
                    {
                        name: "Credit Life policies",
                        value: "CHL - Credit Life policies",
                    },
                    { name: "Legal Assist", value: "MDR - Legal Assist" },
                    { name: "E Plan", value: "ELP - E Plan" },
                    {
                        name: "Flexi funeral on Sapphire",
                        value: "FUN - Flexi funeral on Sapphire",
                    },
                ];
            case "PersonalAccidentPlan":
                return [
                    {
                        name: "Employee Protection Plan",
                        value: "EPP - Employee Protection Plan",
                    },
                    { name: "Funeral Lite", value: "FNL - Funeral Lite" },
                    { name: "Funeral", value: "FNR - Funeral" },
                    {
                        name: "Flexible funeral policy on Mobility",
                        value: "TMA/FMA - Flexible funeral policy on Mobility",
                    },
                    {
                        name: "Personal Accident and Hospital",
                        value: "MDR - Personal Accident and Hospital",
                    },
                    {
                        name: "Credit Life policies",
                        value: "CHL - Credit Life policies",
                    },
                    { name: "Legal Assist", value: "MDR - Legal Assist" },
                    { name: "E Plan", value: "ELP - E Plan" },
                    {
                        name: "Flexi funeral on Sapphire",
                        value: "FUN - Flexi funeral on Sapphire",
                    },
                ];
            case "TravelInsurance":
                return [
                    {
                        name: "Employee Protection Plan",
                        value: "EPP - Employee Protection Plan",
                    },
                    { name: "Funeral Lite", value: "FNL - Funeral Lite" },
                    { name: "Funeral", value: "FNR - Funeral" },
                    {
                        name: "Flexible funeral policy on Mobility",
                        value: "TMA/FMA - Flexible funeral policy on Mobility",
                    },
                    {
                        name: "Personal Accident and Hospital",
                        value: "MDR - Personal Accident and Hospital",
                    },
                    {
                        name: "Credit Life policies",
                        value: "CHL - Credit Life policies",
                    },
                    { name: "Legal Assist", value: "MDR - Legal Assist" },
                    { name: "E Plan", value: "ELP - E Plan" },
                    {
                        name: "Flexi funeral on Sapphire",
                        value: "FUN - Flexi funeral on Sapphire",
                    },
                ];
            case "LegalAssist":
                return [
                    {
                        name: "Employee Protection Plan",
                        value: "EPP - Employee Protection Plan",
                    },
                    { name: "Funeral Lite", value: "FNL - Funeral Lite" },
                    { name: "Funeral", value: "FNR - Funeral" },
                    {
                        name: "Flexible funeral policy on Mobility",
                        value: "TMA/FMA - Flexible funeral policy on Mobility",
                    },
                    {
                        name: "Personal Accident and Hospital",
                        value: "MDR - Personal Accident and Hospital",
                    },
                    {
                        name: "Credit Life policies",
                        value: "CHL - Credit Life policies",
                    },
                    { name: "Legal Assist", value: "MDR - Legal Assist" },
                    { name: "E Plan", value: "ELP - E Plan" },
                    {
                        name: "Flexi funeral on Sapphire",
                        value: "FUN - Flexi funeral on Sapphire",
                    },
                ];
            // Return All Products
            default:
                return [
                    {
                        name: "Employee Protection Plan",
                        value: "EPP - Employee Protection Plan",
                    },
                    { name: "Funeral Lite", value: "FNL - Funeral Lite" },
                    { name: "Funeral", value: "FNR - Funeral" },
                    {
                        name: "Flexible funeral policy on Mobility",
                        value: "TMA/FMA - Flexible funeral policy on Mobility",
                    },
                    {
                        name: "Personal Accident and Hospital",
                        value: "MDR - Personal Accident and Hospital",
                    },
                    {
                        name: "Credit Life policies",
                        value: "CHL - Credit Life policies",
                    },
                    { name: "Legal Assist", value: "MDR - Legal Assist" },
                    { name: "E Plan", value: "ELP - E Plan" },
                    {
                        name: "Flexi funeral on Sapphire",
                        value: "FUN - Flexi funeral on Sapphire",
                    },
                ];
        }
    };
    // Debt Insurance Products
    FormItemInsurancePersonalServicePlanForm.prototype.getDebtInsuranceProducts = function (subCategory) {
        switch (subCategory) {
            case "CreditCard":
                return [
                    {
                        name: "Credit Life policies",
                        value: "CHL - Credit Life policies",
                    },
                    { name: "SIL Topup (ACB)", value: "TUC - SIL Topup (ACB)" },
                    {
                        name: "Home Loan Protection",
                        value: "HLP - Home Loan Protection",
                    },
                ];
            case "Loans":
                return [
                    {
                        name: "Credit Life policies",
                        value: "CHL - Credit Life policies",
                    },
                    { name: "SIL Topup (ACB)", value: "TUC - SIL Topup (ACB)" },
                    {
                        name: "Home Loan Protection",
                        value: "HLP - Home Loan Protection",
                    },
                ];
            case "CarFinanceShortfall":
            case "CarFinanceProtection":
            case "HomeLoanProtection":
                return [
                    {
                        name: "Credit Life policies",
                        value: "CHL - Credit Life policies",
                    },
                    { name: "SIL Topup (ACB)", value: "TUC - SIL Topup (ACB)" },
                    {
                        name: "Home Loan Protection",
                        value: "HLP - Home Loan Protection",
                    },
                ];
            // Return All Products
            default:
                return [
                    {
                        name: "Credit Life policies",
                        value: "CHL - Credit Life policies",
                    },
                    { name: "SIL Topup (ACB)", value: "TUC - SIL Topup (ACB)" },
                    {
                        name: "Home Loan Protection",
                        value: "HLP - Home Loan Protection",
                    },
                ];
        }
    };
    // Commercial Insurance Products
    FormItemInsurancePersonalServicePlanForm.prototype.getCommercialInsuranceProducts = function (subCategory) {
        switch (subCategory) {
            case "SectionalTitle":
                return [
                    { name: "Sectional Title", value: "BCI - Sectional Title" },
                    { name: "Bondsure", value: "CPF - Bondsure" },
                    { name: "Farming", value: "FAR - Farming" },
                    { name: "Engineering", value: "ENG - Engineering" },
                    { name: "Commercial", value: "COM - Commercial" },
                    {
                        name: "Business Insurance",
                        value: "BZS - Business Insurance",
                    },
                    {
                        name: "Non SILC Products",
                        value: "PSB/SBW - Non SILC Products",
                    },
                ];
            case "Bondsure":
                return [
                    { name: "Sectional Title", value: "BCI - Sectional Title" },
                    { name: "Bondsure", value: "CPF - Bondsure" },
                    { name: "Farming", value: "FAR - Farming" },
                    { name: "Engineering", value: "ENG - Engineering" },
                    { name: "Commercial", value: "COM - Commercial" },
                    {
                        name: "Business Insurance",
                        value: "BZS - Business Insurance",
                    },
                    {
                        name: "Non SILC Products",
                        value: "PSB/SBW - Non SILC Products",
                    },
                ];
            case "Farming":
                return [
                    { name: "Sectional Title", value: "BCI - Sectional Title" },
                    { name: "Bondsure", value: "CPF - Bondsure" },
                    { name: "Farming", value: "FAR - Farming" },
                    { name: "Engineering", value: "ENG - Engineering" },
                    { name: "Commercial", value: "COM - Commercial" },
                    {
                        name: "Business Insurance",
                        value: "BZS - Business Insurance",
                    },
                    {
                        name: "Non SILC Products",
                        value: "PSB/SBW - Non SILC Products",
                    },
                ];
            case "Engineering":
                return [
                    { name: "Sectional Title", value: "BCI - Sectional Title" },
                    { name: "Bondsure", value: "CPF - Bondsure" },
                    { name: "Farming", value: "FAR - Farming" },
                    { name: "Engineering", value: "ENG - Engineering" },
                    { name: "Commercial", value: "COM - Commercial" },
                    {
                        name: "Business Insurance",
                        value: "BZS - Business Insurance",
                    },
                    {
                        name: "Non SILC Products",
                        value: "PSB/SBW - Non SILC Products",
                    },
                ];
            case "Commercial":
                return [
                    { name: "Sectional Title", value: "BCI - Sectional Title" },
                    { name: "Bondsure", value: "CPF - Bondsure" },
                    { name: "Farming", value: "FAR - Farming" },
                    { name: "Engineering", value: "ENG - Engineering" },
                    { name: "Commercial", value: "COM - Commercial" },
                    {
                        name: "Business Insurance",
                        value: "BZS - Business Insurance",
                    },
                    {
                        name: "Non SILC Products",
                        value: "PSB/SBW - Non SILC Products",
                    },
                ];
            case "BusinessInsurance":
                return [
                    { name: "Sectional Title", value: "BCI - Sectional Title" },
                    { name: "Bondsure", value: "CPF - Bondsure" },
                    { name: "Farming", value: "FAR - Farming" },
                    { name: "Engineering", value: "ENG - Engineering" },
                    { name: "Commercial", value: "COM - Commercial" },
                    {
                        name: "Business Insurance",
                        value: "BZS - Business Insurance",
                    },
                    {
                        name: "Non SILC Products",
                        value: "PSB/SBW - Non SILC Products",
                    },
                ];
            case "NonSILCProducts":
                return [
                    { name: "Sectional Title", value: "BCI - Sectional Title" },
                    { name: "Bondsure", value: "CPF - Bondsure" },
                    { name: "Farming", value: "FAR - Farming" },
                    { name: "Engineering", value: "ENG - Engineering" },
                    { name: "Commercial", value: "COM - Commercial" },
                    {
                        name: "Business Insurance",
                        value: "BZS - Business Insurance",
                    },
                    {
                        name: "Non SILC Products",
                        value: "PSB/SBW - Non SILC Products",
                    },
                ];
            // Return All Products
            default:
                return [
                    { name: "Sectional Title", value: "BCI - Sectional Title" },
                    { name: "Bondsure", value: "CPF - Bondsure" },
                    { name: "Farming", value: "FAR - Farming" },
                    { name: "Engineering", value: "ENG - Engineering" },
                    { name: "Commercial", value: "COM - Commercial" },
                    {
                        name: "Business Insurance",
                        value: "BZS - Business Insurance",
                    },
                    {
                        name: "Non SILC Products",
                        value: "PSB/SBW - Non SILC Products",
                    },
                ];
        }
    };
    // All Insurance Products
    FormItemInsurancePersonalServicePlanForm.prototype.getAllInsuranceProducts = function () {
        return [
            {
                name: "Hollard Personal Lines",
                value: "HOP - Hollard Personal Lines",
            },
            { name: "SIL Topup (ACB)", value: "TUC - SIL Topup (ACB)" },
            { name: "SIL Touch-up", value: "TUP - SIL Touch-up" },
            { name: "SBVAF", value: "STN - SBVAF" },
            { name: "Stansure", value: "STH - Stansure" },
            { name: "Motorfleet", value: "MTF - Motorfleet" },
            {
                name: "King Price Insurance",
                value: "KPI - King Price Insurance",
            },
            { name: "SAU", value: "SAU - SAU" },
            {
                name: "Standard Road Accident Top-Up",
                value: "SRA - Standard Road Accident Top-Up",
            },
            {
                name: "Elite Sure - SAU Broker",
                value: "ELS - Elite Sure - SAU Broker",
            },
            {
                name: "Elite Sure - SAU Conversion",
                value: "ELS - Elite Sure - SAU Conversion",
            },
            { name: "Stansure Blue", value: "STB - Stansure Blue" },
            { name: "Elite Sure", value: "SAU - Elite Sure" },
            { name: "SIL Direct", value: "SIL - SIL Direct" },
            { name: "Liberty Short Term", value: "SHL - Liberty Short Term" },
            { name: "Homeloans", value: "HLB - Homeloans" },
            { name: "Own Arrangements", value: "OWN - Own Arrangements" },
            { name: "Homeloans ACB", value: "HLC - Homeloans ACB" },
            { name: "Business Mortgage", value: "BMB - Business Mortgage" },
            { name: "Low Income - group", value: "EBK - Low Income - group" },
            { name: "Stansure Select", value: "SHS - Stansure Select" },
            { name: "First For Woman", value: "FFW - First For Woman" },
            { name: "Access Account Plus", value: "AAP - Access Account Plus" },
            { name: "Burial Society", value: "BRS - Burial Society" },
            {
                name: "Funeral Community Banking",
                value: "FCB - Funeral Community Banking",
            },
            {
                name: "Employee Protection Plan",
                value: "EPP - Employee Protection Plan",
            },
            { name: "Funeral Lite", value: "FNL - Funeral Lite" },
            { name: "Funeral", value: "FNR - Funeral" },
            {
                name: "Flexible funeral policy on Mobility",
                value: "TMA/FMA - Flexible funeral policy on Mobility",
            },
            { name: "Level Life", value: "LVL - Level Life" },
            {
                name: "Credit Life policies",
                value: "CHL - Credit Life policies",
            },
            {
                name: "Home Loan Protection",
                value: "HLP - Home Loan Protection",
            },
            {
                name: "Group Schemes funeral policy",
                value: "GRP - Group Schemes funeral policy",
            },
            { name: "E Plan", value: "ELP - E Plan" },
            {
                name: "Flexi funeral on Sapphire",
                value: "FUN - Flexi funeral on Sapphire",
            },
            { name: "MDR", value: "MDR - MDR" },
            {
                name: "Personal Accident and Hospital",
                value: "MDR - Personal Accident and Hospital",
            },
            { name: "Legal Assist", value: "MDR - Legal Assist" },
            { name: "Sectional Title", value: "BCI - Sectional Title" },
            { name: "Bondsure", value: "CPF - Bondsure" },
            { name: "Farming", value: "FAR - Farming" },
            { name: "Engineering", value: "ENG - Engineering" },
            { name: "Commercial", value: "COM - Commercial" },
            { name: "Business Insurance", value: "BZS - Business Insurance" },
            { name: "Non SILC Products", value: "PSB/SBW - Non SILC Products" },
        ];
    };
    FormItemInsurancePersonalServicePlanForm.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemInsurancePersonalServicePlanForm;
}(Base));
export { FormItemInsurancePersonalServicePlanForm };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-insurance-personal-service-plan-form/form-item-insurance-personal-service-plan-form.component.ts
// module id = 1085
// module chunks = 0